export default "__VITE_ASSET__CSn3N414__"